/*!
 * Copyright (C) Octillion Media LLC 2019
 * All Rights Reserved.
 */
import { mapState, mapGetters, mapActions} from 'vuex'

export const authComputed = {
    ...mapState('auth', {
        currentUser: (state) => state.user,
        loginStatus: (state) => state.loginStatus,
        checkEmailExistForgetPassword: (state) => state.checkEmailExistForgetPassword,
        forgetPassRequestSuccess: (state) => state.forgetPassRequestSuccess,
        forgetPassRequestErr: (state) => state.forgetPassRequestErr,
        updateForgetPasswordSuccess: (state) => state.updateForgetPasswordSuccess,
        updateForgetPasswordErr: (state) => state.updateForgetPasswordErr,
    }),
    ...mapGetters('auth', ['loggedIn']),
}
export const authMethods = mapActions('auth', ['logIn',
    'logout',
    'register',
    'resetPassword',
    'signIn',
    'switchAcct',
    'checkEmailExistForgetPassFunc',
    'requestResetPassword',
    'clearForgetPassword'
])

export const layoutComputed = {
    ...mapState('layout', {
        layoutType: (state) => state.layoutType,
        leftSidebarType: (state) => state.leftSidebarType,
        layoutWidth: (state) => state.layoutWidth,
        topbar: (state) => state.topbar,
        loader: (state) => state.loader
    })
}

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])


export const topNavComputed = {
    ...mapState('navbar', {
        dateFilter: (state) => state.dateFilter,
        isCompare: (state) => state.isCompare,
        headerTitle: (state) => state.headerTitle
    })
}
export const topNavMethods = mapActions('navbar', ['setTitle', 'updateDateRange', 'setCompare']);


export const notificationComputed = {
    ...mapState('notification', {
        searchResult: (state) => state.searchResult,
    })
}
export const notificationMethods = mapActions('notification', ['success', 'error', 'clear', 'fetchSearchResult', 'clearSearchResult'])

export const activityLogComputed = {
    ...mapState('activitylog', {
        activityLogList: (state) => state.activityLogList
    })
}
export const activityLogMethods = mapActions('activitylog', ['getActivityLog', 'clearActivityLog'])


// accounts Section
export const accountComputed = {
    ...mapState('account', {
        accounts: (state) => state.accounts,
        accountResponses: state => state.accountResponses,
        accountErr: (state) => state.accountErr,
        accountSuccess: (state) => state.accountSuccess,
        accountSingleData: state => state.accountSingleData,
        accountDeleteStatus: (state) => state.accountDeleteStatus,
    })
}
export const accountMethods = mapActions('account', [
    'fetchAccounts',
    'fetchSingleAccount',
    'clearDeleteAccount',
    'putAccount',
    'postAccount',
    'postFullAccount',
    'putFullAccount',
    'fetchFullSingleAccount',
    'deleteAccount',
    'clearAccount'])

export const campaignMethods = mapActions('campaign', ['setCampaignStep', 'fetchCampaigns', 'onChangeSport', 'resetCampaign', 'fetchSingleCampaign', 'setCampaignMode'])
export const campaignComputed = {
    ...mapState('campaign', {
        campaignCurrentStep: (state) => state.campaignCurrentStep,
        selectedSport: (state) => state.selectedSport,
        sports: (state) => state.sports,
        campaigns: (state) => state.campaigns,
        leagues: (state) => state.leagues,
        teams: (state) => state.teams,
        games: (state) => state.games,
        selectedLeagues: (state) => state.selectedLeagues,
        selectedTeams: (state) => state.selectedTeams,
        selectedGames: (state) => state.selectedGames,
        selectedLiveEvents: (state) => state.selectedLiveEvents,
        selectedCreatives: (state) => state.selectedCreatives,
        campaignForm: (state) => state.campaignForm,
        campaignLoader: (state) => state.campaignLoader,
        campaignMode: (state) => state.campaignMode,
        campaignSingleErr: (state) => state.campaignSingleErr,
    }),
    ...mapGetters('campaign', ['loader']),
    leaguesCount: (state) => Array.isArray(state.leagues) ? state.leagues.length : 0,
    teamsCount: (state) => Array.isArray(state.teams) ? state.teams.length : 0,
    gamesCount: (state) => Array.isArray(state.games) ? state.games.length : 0,
    advertiser_id: state => state.campaignForm?.advertiser?.advertiser_id || null
}



// advertiser Section
export const advertiserComputed = {
    ...mapState('advertiser', {
        advertisers: (state) => state.advertisers,
        advertisersListData: (state) => state.advertisersListData,
    })
}
export const advertiserMethods = mapActions('advertiser', ['fetchAdvertisers'])

//Users
export const usersComputed = {
    ...mapState('users', {
        users: (state) => state.users,
        userSuccess: (state) => state.userSuccess,
        usersDeleteStatus: (state) => state.usersDeleteStatus,
        userErr: state => state.userErr,
        userSingleData: state => state.userSingleData,
        emailExists: state => state.emailExists,
        domainNotAllow: state => state.domainNotAllow,
        usersDownload: (state) => state.usersDownload,

    })
}
export const usersMethods = mapActions('users', ['fetchUsers',
    'postUser',
    'clearUser',
    'fetchSingleUser',
    'putUser',
    'putUserProfile',
    'deleteUser',
    'isEmailExists',
    'clearIsEamilExist',
    'clearUserErr',
    'clearDeleteUser',
    'exportUsersRecord'
])
